import {
    currencyLongFormatter,
    currencyMediumFormatter,
    currencyRoundFormatter,
    currencyShortFormatter,
    numberLongFormatter,
    numberShortFormatter,
    numberShortRoundFormatter,
} from '../globalize/globalize-formatters';
import moment from 'moment';

const registerFilters = (app) => {
    app.config.globalProperties.$filters = {};

    const filters = app.config.globalProperties.$filters;

    filters['time'] = time;
    filters['timeLocal'] = timeLocal;
    filters['datetime'] = datetime;
    filters['datetimeLocal'] = datetimeLocal;
    filters['date'] = date;
    filters['dateLocal'] = dateLocal;
    filters['fullDate'] = fullDate;
    filters['fullDateWithTextMonth'] = fullDateWithTextMonth;

    filters['ago'] = ago;
    filters['timeAgoOrDate'] = timeAgoOrDate;
    filters['formatNumber'] = formatNumber;
    filters['formatPrice'] = formatPrice;
};

const filterWarn = (fName) => console.warn(`[Migration varn] Function ${fName} used as filter and should be reimplemented without filter notation`);

const time = (value) => {
    filterWarn(time.name);
    return formatTime(value, 'LT');
};

const timeLocal = (value) => {
    filterWarn(timeLocal.name);
    return formatTimeLocal(value, 'LT');
};

const datetime = (value) => {
    filterWarn(datetime.name);
    return formatTime(value, 'lll');
};

const datetimeLocal = (value) => {
    filterWarn(datetimeLocal.name);
    return formatTimeLocal(value, 'lll');
};

const date = (value) => {
    filterWarn(date.name);
    return formatTime(value, 'D MMMM, dddd');
};

const dateLocal = (value) => {
    filterWarn(dateLocal.name);
    return formatTimeLocal(value, 'D MMMM, dddd');
};

const fullDate = (value) =>{
    filterWarn(fullDate.name);
    return formatTime(value, 'L');
};

const fullDateWithTextMonth = (value) => {
    filterWarn(fullDateWithTextMonth.name);
    return formatTime(value, 'D MMMM YYYY');
};

const formatTime = (value, format) => {
    filterWarn(formatTime.name);
    return moment(value).format(format);
};

const formatTimeLocal = (value, format) => {
    filterWarn(formatTimeLocal.name);
    return moment.utc(value).local().format(format);
};

const timeAgoOrDate = (value) => {
    filterWarn(timeAgoOrDate.name);
    if (!value) {
        return value;
    }

    let utcValue = moment.utc(value);
    const utcNow = moment.utc();

    if (utcNow.diff(utcValue, 'hours') > 12) {
        return utcValue.local().format('lll');
    }

    if (utcNow.diff(utcValue, 'hours') > 1) {
        return utcValue.local().format('LT');
    }

    if (utcValue.isAfter(utcNow)) {
        utcValue = utcNow;
    }

    return utcValue.local().fromNow(false);
};

const ago = (value) => {
    filterWarn(ago.name);
    if (!value) {
        return value;
    }

    let utcValue = moment.utc(value);
    const utcNow = moment.utc();

    if (utcValue.isAfter(utcNow)) {
        utcValue = utcNow;
    }

    return utcValue.local().fromNow(false);
};

const formatNumber = (value, locale, formatterType = 'long') => {
    filterWarn(formatNumber.name);
    if (!value) {
        return value;
    }

    let formatter;
    switch (formatterType) {
    case 'short':
        formatter = numberShortFormatter(locale);
        break;
    case 'shortRound':
        formatter = numberShortRoundFormatter(locale);
        break;
    case 'long':
    default:
        formatter = numberLongFormatter(locale);
        break;
    }

    return formatter(value);
};

const formatPrice = (text, formatterType = 'long', isoCurrency) => {
    filterWarn(formatPrice.name);
    if (text === undefined || text === null || !text.toString()) {
        return '';
    }

    const preferredCurrencySymbolToReplace = preferredCurrencySymbol;
    const floatNumberRegExp = /(\b\d+([,.]\d+)?\b)/g;
    return text.toString().replace(floatNumberRegExp,
        (number) => {
            let price = Globalize.parseNumber(number);
            if (isNaN(price)) {
                price = parseFloat(number);
            }
            isoCurrency = isoCurrency || defaultISOCurrency;
            const formatter = getCurrencyFormatter(formatterType, isoCurrency, price);
            return formatter(price).replace(isoCurrency, preferredCurrencySymbolToReplace).replace(/\u00a0/g, ' ');
        });
};

const getCurrencyFormatter = (formatterType, currency, number) => {
    const createdFormatters = {};
    let formatter;

    if (formatterType === 'adaptive') {
        formatter = number >= 10000 ? getCurrencyFormatter('short', currency) : getCurrencyFormatter('round', currency);
    } else if (createdFormatters[formatterType + currency]) {
        formatter = createdFormatters[formatterType + currency];
    } else {
        switch (formatterType) {
        case 'short':
            formatter = currencyShortFormatter(currency);
            break;
        case 'medium':
            formatter = currencyMediumFormatter(currency);
            break;
        case 'round':
            formatter = currencyRoundFormatter(currency);
            break;
        case 'long':
        default:
            formatter = currencyLongFormatter(currency);
            break;
        }

        createdFormatters[formatterType + currency] = formatter;
    }

    return formatter;
};

let defaultISOCurrency;
let preferredCurrencySymbol;

const setDefaultCurrencyForPriceFormatting = (isoCurrency, currencySymbol) => {
    defaultISOCurrency = isoCurrency;
    preferredCurrencySymbol = currencySymbol;
};

export {setDefaultCurrencyForPriceFormatting, registerFilters};
